import { Column } from '@devexpress/dx-react-grid'

export const COLUMNS: Column[] = [
  {
    name: 'fullName',
    title: 'Name',
  },
  {
    name: 'lastPayment',
    title: 'Last Payment',
  },
  {
    name: 'moveOut',
    title: 'Move Out',
  },
  {
    name: 'paymentStatus',
    title: 'Status',
  },
  {
    name: 'unitNumber',
    title: 'Unit Number',
  },
]
